<template>
  <div class="dashboard__card" v-cloak>
    <CardLoading v-if="loaders.connections"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.connections }" v-cloak>
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Connections</div>
        <span class="dashboard__card-title-addendum">{{ dataRange }}</span>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--fuel-utilization"><i class="fa fa-tasks"></i></div>
      </div>
      <div class="dashboard__card-body dashboard__card-body--bordered-top">
        <ConnectionsChart></ConnectionsChart>
      </div>
    </div>
  </div>

</template>

<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import CardLoading from './CardLoading.vue';
  import ConnectionsChart from '../connections/ConnectionsChart.vue';

  export default {
    name: 'ConnectionsCard',
    components: {
      CardLoading,
      ConnectionsChart,
    },
    data() {
      return {
        dateFrom: moment().subtract('3', 'months'),
        dateTo: moment(),
      };
    },
    computed: {
      ...mapGetters('connections', ['loaders']),
      dataRange() {
        return `${this.dateFrom.format('MMM D, YYYY')} - ${this.dateTo.format('MMM D, YYYY')}`;
      }
    },
  };
</script>
